import { Head, useAuth } from "zudoku/components";
import { useEffect } from "react";

export const SubscriptionsCustomTestPage = () => {
  const auth = useAuth();

  // Extract user email from auth.user or token
  const getUserEmail = () => {
    if ((auth.user as any)?.email) {
      return (auth.user as any).email;
    }
    try {
      const raw = localStorage.getItem("auth-state");
      const token = JSON.parse(raw ?? "{}")?.state?.providerData?.accessToken;
      if (!token) return "";
      const base64Url = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
      const payload = JSON.parse(
        decodeURIComponent(
          atob(base64Url)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join("")
        )
      );
      return payload["https://api.securitydatapoint.com/email"] || payload.email || "";
    } catch {
      return "";
    }
  };

  const userEmail = getUserEmail();
  
  if (!userEmail) {
    console.error("Unable to retrieve user email from auth.user or JWT payload");
  }

  useEffect(() => {
    // Load Stripe Pricing Table script
    const script = document.createElement("script");
    script.src = "https://js.stripe.com/v3/pricing-table.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="max-w-6xl mx-auto px-4 py-12">
      <Head>
        <title>Subscriptions - SDP Developer Portal</title>
      </Head>
      
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold mb-4">Choose Your Plan</h1>
        <p className="text-lg text-gray-600 dark:text-gray-400">
          Select a subscription plan that fits your needs
        </p>
      </div>

      <div className="rounded-lg overflow-hidden">
        {/* @ts-ignore */}
        <stripe-pricing-table
          pricing-table-id="prctbl_1SkPLQAevyYhrEbt5G6HHcXd"
          publishable-key="pk_test_51SjtACAevyYhrEbtPj0LPNfW21pHsuFl57KeS6y3j3a7sRrw3UwAXuDkuLkpYPTYmH9C32CoQk3mZ8LOacjrQTvW00dgiaAUP3"
          customer-email={userEmail}
        />
      </div>
    </section>
  );
};